"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_LOGIN_ACTION = exports.AUTHENTICATION_METHOD = exports.IDENTIFIER_TYPE = void 0;
var IDENTIFIER_TYPE;
(function (IDENTIFIER_TYPE) {
    IDENTIFIER_TYPE["EMAIL"] = "EMAIL";
    IDENTIFIER_TYPE["PHONE"] = "PHONE";
})(IDENTIFIER_TYPE = exports.IDENTIFIER_TYPE || (exports.IDENTIFIER_TYPE = {}));
var AUTHENTICATION_METHOD;
(function (AUTHENTICATION_METHOD) {
    AUTHENTICATION_METHOD["MAGIC_LINK"] = "MAGIC_LINK";
    AUTHENTICATION_METHOD["OTP"] = "OTP";
})(AUTHENTICATION_METHOD = exports.AUTHENTICATION_METHOD || (exports.AUTHENTICATION_METHOD = {}));
var SOCIAL_LOGIN_ACTION;
(function (SOCIAL_LOGIN_ACTION) {
    SOCIAL_LOGIN_ACTION["LOGIN"] = "O_LOGIN";
    SOCIAL_LOGIN_ACTION["CONNECT"] = "O_CONNECT";
})(SOCIAL_LOGIN_ACTION = exports.SOCIAL_LOGIN_ACTION || (exports.SOCIAL_LOGIN_ACTION = {}));
//# sourceMappingURL=binder.js.map